var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    { attrs: { title: _vm.titleLabel, iconFA: "address-book" } },
    [
      _c("template", { slot: "pageContent" }, [
        _vm.type === "1"
          ? _c(
              "fieldset",
              [
                _c("legend", { staticClass: "sr-only" }, [
                  _vm._v(_vm._s(_vm.$t("administration.company_information"))),
                ]),
                _vm._v(" "),
                _c(
                  "b-row",
                  { staticClass: "justify-content-start" },
                  [
                    _c(
                      "b-col",
                      { staticClass: "form-group", attrs: { sm: "6" } },
                      [
                        _c("form-write-group-label-input", {
                          attrs: {
                            isMandatory: "",
                            inputLabel: _vm.$t("administration.company_name"),
                            placeholderValue: _vm.$t(
                              "administration.company_name"
                            ),
                          },
                          model: {
                            value: _vm.companyName,
                            callback: function ($$v) {
                              _vm.companyName = $$v
                            },
                            expression: "companyName",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { staticClass: "form-group", attrs: { sm: "6" } },
                      [
                        _c("form-write-group-label-input", {
                          attrs: {
                            isMandatory: "",
                            inputLabel: _vm.$t("administration.company_number"),
                            placeholderValue: _vm.$t(
                              "administration.company_number"
                            ),
                          },
                          model: {
                            value: _vm.companyNumber,
                            callback: function ($$v) {
                              _vm.companyNumber = $$v
                            },
                            expression: "companyNumber",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { staticClass: "form-group", attrs: { sm: "6" } },
                      [
                        _c("form-write-group-label-input", {
                          attrs: {
                            isMandatory: "",
                            inputLabel: _vm.$t("administration.company_email"),
                            placeholderValue: _vm.$t(
                              "administration.company_email"
                            ),
                          },
                          model: {
                            value: _vm.companyEmail,
                            callback: function ($$v) {
                              _vm.companyEmail = $$v
                            },
                            expression: "companyEmail",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { staticClass: "form-group", attrs: { sm: "6" } },
                      [
                        _c(
                          "form-write-group-label-input",
                          {
                            attrs: {
                              isMandatory: "",
                              inputLabel: _vm.$t("administration.country"),
                              inputType: "listeSelect",
                              id: "country-select-group-company",
                            },
                          },
                          [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.selectedCountry,
                                    expression: "selectedCountry",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  readonly: "",
                                  id: "country-select-group-company-data",
                                  "aria-required": true,
                                  "aria-describedby":
                                    _vm.selectedCountry === ""
                                      ? "country-company-error"
                                      : null,
                                  "aria-invalid":
                                    _vm.selectedCountry === ""
                                      ? "true"
                                      : "false",
                                },
                                on: {
                                  change: function ($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call(
                                        $event.target.options,
                                        function (o) {
                                          return o.selected
                                        }
                                      )
                                      .map(function (o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.selectedCountry = $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  },
                                },
                              },
                              [
                                _c("option", { attrs: { value: "" } }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("administration.country_select")
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _vm._l(_vm.countries, function (country) {
                                  return _c(
                                    "option",
                                    {
                                      key: country,
                                      domProps: { value: country },
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(country) +
                                          "\n              "
                                      ),
                                    ]
                                  )
                                }),
                              ],
                              2
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.type === "2"
          ? _c(
              "fieldset",
              [
                _c("legend", { staticClass: "sr-only" }, [
                  _vm._v(_vm._s(_vm.$t("administration.user_information"))),
                ]),
                _vm._v(" "),
                _c(
                  "b-row",
                  { staticClass: "justify-content-start" },
                  [
                    _c(
                      "b-col",
                      { staticClass: "form-group", attrs: { sm: "6" } },
                      [
                        _c("form-write-group-label-input", {
                          attrs: {
                            isMandatory: "",
                            inputLabel: _vm.$t("administration.user_last_name"),
                            placeholderValue: _vm.$t(
                              "administration.user_last_name"
                            ),
                          },
                          model: {
                            value: _vm.userLastName,
                            callback: function ($$v) {
                              _vm.userLastName = $$v
                            },
                            expression: "userLastName",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { staticClass: "form-group", attrs: { sm: "6" } },
                      [
                        _c("form-write-group-label-input", {
                          attrs: {
                            isMandatory: "",
                            inputLabel: _vm.$t(
                              "administration.user_first_name"
                            ),
                            placeholderValue: _vm.$t(
                              "administration.user_first_name"
                            ),
                          },
                          model: {
                            value: _vm.userFirstName,
                            callback: function ($$v) {
                              _vm.userFirstName = $$v
                            },
                            expression: "userFirstName",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { staticClass: "form-group", attrs: { sm: "6" } },
                      [
                        _c("form-write-group-label-input", {
                          attrs: {
                            isMandatory: "",
                            inputLabel: _vm.$t("administration.user_email"),
                            placeholderValue: _vm.$t(
                              "administration.user_email"
                            ),
                          },
                          model: {
                            value: _vm.userEmail,
                            callback: function ($$v) {
                              _vm.userEmail = $$v
                            },
                            expression: "userEmail",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { staticClass: "form-group", attrs: { sm: "6" } },
                      [
                        _c(
                          "form-write-group-label-input",
                          {
                            attrs: {
                              isMandatory: "",
                              inputLabel: _vm.$t("administration.country"),
                              inputType: "listeSelect",
                              id: "country-select-group-user",
                            },
                          },
                          [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.selectedCountry,
                                    expression: "selectedCountry",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  readonly: "",
                                  id: "country-select-group-user-data",
                                  "aria-required": true,
                                  "aria-describedby":
                                    _vm.selectedCountry === ""
                                      ? "country-user-error"
                                      : null,
                                  "aria-invalid":
                                    _vm.selectedCountry === ""
                                      ? "true"
                                      : "false",
                                },
                                on: {
                                  change: function ($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call(
                                        $event.target.options,
                                        function (o) {
                                          return o.selected
                                        }
                                      )
                                      .map(function (o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.selectedCountry = $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  },
                                },
                              },
                              [
                                _c("option", { attrs: { value: "" } }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("administration.country_select")
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _vm._l(_vm.countries, function (country) {
                                  return _c(
                                    "option",
                                    {
                                      key: country,
                                      domProps: { value: country },
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(country) +
                                          "\n              "
                                      ),
                                    ]
                                  )
                                }),
                              ],
                              2
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        "template",
        { slot: "footerButtons" },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { md: "2", "offset-md": "9" } },
                [
                  _c(
                    "f7-button",
                    {
                      staticClass: "button-action milkyBlockBlack",
                      on: { click: _vm.addUser },
                    },
                    [
                      _c("f7-icon", { attrs: { fa: "save" } }),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.$t("common.sve")))]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }